import { init } from '@atlaskit/react-ufo/interaction-metrics-init';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { getEnvType } from '../..';
import { envType } from '../../../common/types';

const isProd = getEnvType() === envType.PROD;
const region = isProd ? 'prod-east' : 'stg-east';
const config = {
	product: 'devAgents',
	namePrefix: 'dev-agents-ufo-',
	region,
	interactionTimeout: { 'dev-agents-ufo-dev-agents-boysenberry-flow-page': 180000 }, // 3 minutes
	capability: {
		/*
		 * Enabling feature flag data to be captured in UFO.
		 */
		feature_flag_access: 1,
		/*
		 * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
		 * react_profiler is added since it is required by the type,
		 * will be cleaned up in the future
		 */
		react_profiler: 0,
	},
	vc: {
		/*
		 * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
		 */
		stopVCAtInteractionFinish: true,
		enabled: true,
		ssr: false,
		devToolsEnabled: getEnvType() !== envType.PROD,
		selectorConfig: {
			id: false, // in the example above, since ids may contain UGC, we want to set capturing `id` information for TTVC to `false`.
			role: true,
			className: true,
			testId: true,
		},
	},
	kind: {
		/*
		 * Sampling works in 1 in the rate specified.
		 * If rate is 1, it captures all events - 1/1
		 */
		page_load: 1,
		transition: 1,
		press: 1,
		typing: 1,
		legacy: 0, // For some Jira events that will be cleaned up in UFO
		hover: 1,
	},
	postInteractionLog: {
		enabled: true,
	},
};

export const initReactUFO = (analyticsWebClient: AnalyticsWebClient) => {
	init(Promise.resolve(analyticsWebClient), config);
	traceUFOPageLoad();
};
